import { render, staticRenderFns } from "./PDFview.vue?vue&type=template&id=13a3e532&"
import script from "./PDFview.vue?vue&type=script&lang=js&"
export * from "./PDFview.vue?vue&type=script&lang=js&"
import style0 from "./PDFview.vue?vue&type=style&index=0&id=13a3e532&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports